/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '';
  authUrl: string = '';
  memberCardValidationUrl: string = '';
  clientId: string = '';
  clientSecret: string = '';
  authAudience: string = '';
  validationAuth: string = '';
  validationPath: string = '';
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
